const data = {
    meta : {
        title       : "Project - Developer Software, Website dan Aplikasi Mobile Terbaik di Makassar",
        description : "Kami membantu client kami dengan mendepankan solusi terhadap permasalahan, dan menciptakan aplikasi yang berkelas serta inovatif.",
        imageUrl    : "/images/preview.png",
        imageAlt    : "/images/preview.png"
    },
    banner : {
        id : {
            title : "Portofolio",
            subTitle  : "Kami membantu client kami dengan mendepankan solusi terhadap permasalahan, dan menciptakan aplikasi yang berkelas serta inovatif.",
            buttonText : "Hubungi Sekarang"
        }
    }
}

export default data